import { Component, Input, OnInit } from '@angular/core';
import { faInfo, faClock, faMoneyBill, faUniversalAccess, faSwimmer, faCalendarAlt, faBell, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { first } from 'rxjs/operators';
import { OrganizationsService } from '../organizations.service';

@Component({
    selector: 'app-organization-menu',
    templateUrl: './organization-menu.component.html',
    styleUrls: ['./organization-menu.component.css'],
    standalone: false
})
export class OrganizationMenuComponent implements OnInit {

  @Input() id: number;
  public organizationType: number;
  public icons: { [name: string]: any } = {
    'faInfo': faInfo,
    'faClock': faClock,
    'faMoneyBill': faMoneyBill,
    'faUniversalAccess': faUniversalAccess,
    'faSwimmer': faSwimmer,
    'faCalendarAlt': faCalendarAlt,
    'faBell': faBell,
    'faArrowRight': faArrowRight
  };

  constructor(private _organizationsService: OrganizationsService) { }

  ngOnInit(): void {
    // tslint:disable-next-line:radix
    this.organizationType = parseInt(localStorage.getItem('orgId'));
    if (!this.organizationType) {
      this._organizationsService.organizationTypeSubject.pipe(first()).subscribe(result => {
        this.organizationType = result;
      });
    }
  }
}
